import { useSelector } from "react-redux";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { deleteRefuel, requestDeletingRefuel, selectState } from "../fuelsAndLubricants.slice";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { FormatDateShort } from "utils/dateUtils";

const DeleteRefuelModal = () => {
  const { refuelToDelete } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(requestDeletingRefuel(undefined));
  };

  const doDelete = async () => {
    try {
      if (refuelToDelete !== undefined) {
        await dispatch(deleteRefuel({ resourceId: refuelToDelete.resource.resourceId, refuelId: refuelToDelete.refuelId }));;
        toast.success("Uspesno obrisan.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={refuelToDelete !== undefined}
      title="Brisanje točenja goriva"
    >
      <p className="info-msg">
        {refuelToDelete && `Da li ste sigurni da želite da obrišete točenje goriva (${refuelToDelete.resource.name}, ${FormatDateShort(refuelToDelete.date)}, ${FormatNumberWithUnitOrNull(refuelToDelete.usageAmount, refuelToDelete.usageUnit.name)})?`}
      </p>
    </Modal>
  );
};

export default DeleteRefuelModal;
